(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rock-strip"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('rock-strip')) return;

    class RockStrip extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.rock-strip__track');
        this.speed = parseFloat(this.dataset.speed) || 0.35;
        this._ticking = false;
        this._neighbor = null;
        this._update = this.update.bind(this);
        this._onScroll = () => {
          if (this._ticking) return;
          this._ticking = true;
          window.requestAnimationFrame(() => { this._ticking = false; this._update(); });
        };
        this._onResize = () => { this.measureBleed(); this.applyNeighborRadius(); this._onScroll(); };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        document.addEventListener('scroll', this._onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this._onResize);
        window.addEventListener('load', this._onResize);
        this.measureBleed();
        this.applyNeighborRadius();
        this._update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        document.removeEventListener('scroll', this._onScroll, { capture: true });
        window.removeEventListener('resize', this._onResize);
        window.removeEventListener('load', this._onResize);
      }

      // Cherche, en remontant les parents, un élément placé à gauche de la bande (la photo) et le mémorise.
      findNeighbor() {
        var mine = this.getBoundingClientRect();
        var el = this;
        var depth = 0;
        while (el && el !== document.body && depth < 8) {
          var prev = el.previousElementSibling;
          while (prev) {
            var r = prev.getBoundingClientRect();
            var overlapsY = r.bottom > mine.top && r.top < mine.bottom;
            if (r.width > 0 && r.right <= mine.left + 1 && overlapsY) return prev;
            prev = prev.previousElementSibling;
          }
          el = el.parentElement;
          depth++;
        }
        return null;
      }

      // 1) Voisin à gauche trouvé : la bande s'étire jusqu'à son bord droit.
      // 2) Sinon (mobile, photo au-dessus) : annule le padding gauche de la colonne.
      measureBleed() {
        if (this.dataset.bleedLeft !== 'true') { this._neighbor = this.findNeighbor(); return; }
        this.style.setProperty('--rock-bleed', '0px');
        var mine = this.getBoundingClientRect();
        var bleed = 0;
        var neighbor = this.findNeighbor();
        this._neighbor = neighbor;
        if (neighbor) {
          bleed = mine.left - neighbor.getBoundingClientRect().right;
        } else {
          var p = this.parentElement;
          var pd = 0;
          while (p && p !== document.body && pd < 6) {
            var value = parseFloat(window.getComputedStyle(p).paddingLeft) || 0;
            if (value > 0) { bleed = value; break; }
            p = p.parentElement;
            pd++;
          }
        }
        this.style.setProperty('--rock-bleed', Math.max(0, bleed).toFixed(1) + 'px');
      }

      // Arrondit les angles droits de la photo voisine (ceux qui touchent la bande), en inline pour passer devant le CSS du thème.
      applyNeighborRadius() {
        var r = parseFloat(this.dataset.neighborRadius) || 0;
        var target = this._neighbor;
        if (!target) return;
        var img = target.querySelector('img');
        var value = r > 0 ? '0 ' + r + 'px ' + r + 'px 0' : '';
        target.style.borderRadius = value;
        if (r > 0) target.style.overflow = 'clip';
        if (img) img.style.borderRadius = value;
      }

      // Même calcul que Pléiades : la bande glisse à gauche de (hauteur fenêtre - top de la bande) x vitesse
      update() {
        if (!this.track || this.closest('[hidden]')) return;
        const rect = this.getBoundingClientRect();
        const wh = window.innerHeight;
        if (rect.bottom < 0 || rect.top > wh) return;
        const pos = wh - rect.top;
        this.track.style.transform = 'translateX(-' + (pos * this.speed).toFixed(1) + 'px)';
      }
    }

    customElements.define('rock-strip', RockStrip);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shipping-reassurance"] && !Shopify.designMode) return;
  try {
    /* Calcul de la date de livraison : aujourd'hui + délai en jours ouvrés (reprise de calculateShipping, Pléiades) */
  (function () {
    if (window.__auraShippingInit) return;
    window.__auraShippingInit = true;

    function fill(el) {
      if (el.dataset.auraShippingDone === 'true') return;
      var html = el.innerHTML;
      if (html.indexOf('[date]') === -1) return;

      var delay = parseInt(el.getAttribute('data-shipping-delay'), 10);
      if (isNaN(delay)) delay = 3;

      var date = new Date();
      for (var i = 0; i < delay; i++) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() === 6) date.setDate(date.getDate() + 2);
        if (date.getDay() === 0) date.setDate(date.getDate() + 1);
      }

      var locale = el.getAttribute('data-locale') || 'en';
      var formatted;
      try {
        formatted = date.toLocaleDateString(locale, { weekday: 'long', day: 'numeric', month: 'long' });
      } catch (e) {
        formatted = date.toLocaleDateString('en', { weekday: 'long', day: 'numeric', month: 'long' });
      }

      el.innerHTML = html.replace('[date]', formatted);
      el.dataset.auraShippingDone = 'true';
    }

    function run() {
      document.querySelectorAll('[data-aura-shipping]').forEach(fill);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    /* Re-rendu dans l'éditeur de thème */
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:block:select', run);
  })();
  } catch(e) { console.error(e); }
})();

})();
